import React from 'react';
import ComingSoon from './components/ComingSoon';
import SEOHead from './components/SEOHead';
import Header from './components/Header';
import Footer from './components/Footer';
import { Analytics } from '@vercel/analytics/react';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-white flex flex-col">
        <SEOHead />
        <Header />
        <main className="flex-grow">
          <ComingSoon />
        </main>
        <Footer />
        <Analytics />
      </div>
    </HelmetProvider>
  );
}

export default App;